export enum Environment {
  LOCAL = "local",
  TEST = "test",
  DEV = "dev",
  STAGE = "stage",
  IC = "ic",
}
